
















































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import RolesMixin from '@/mixins/Staff/UserManagement/Roles';
import { Features } from '@/services/Features';

@Component
export default class UmiaRoles extends Mixins(RolesMixin) {
	private readonly environment: string = process.env.VUE_APP_ENV_TYPE;

	private get showCoiCheckbox(): boolean {
		return !Features.isUmiaPolicyDocumentsEnabled;
	}

	private get showPolicyDocsCheckbox(): boolean {
		return Features.isUmiaPolicyDocumentsEnabled;
	}

	private get showPolicyInfoCheckbox(): boolean {
		return !Features.isUmiaPolicyDocumentsEnabled;
	}

	private get showReportingGroup(): boolean {
		return Features.isUmiaPolicyDocumentsEnabled;
	}
}
